import { CreditConditionalItem } from '@indigo-ag/schema';
import { ConditionalsValidationRow } from './ConditionalsTable.config';

export const createFromImportedConditionals = (importedConditionals: string[]) => {
  return importedConditionals.map((conditional, index) => ({
    id: index + 1,
    conditional,
    observation: '',
    validated: false
  }));
};

export const createFromCreditApprovalData = (conditionals: CreditConditionalItem[]) => {
  return conditionals.map<ConditionalsValidationRow>(conditional => ({
    id: conditional.id,
    conditional: conditional.name,
    observation: conditional.observation ?? '',
    validated: conditional.validated
  }));
};
